export function FieldError({ message }: { message?: string }) {
	if (!message) return null;

	return (
		<p role="alert" className="mt-1 text-sm font-medium text-red-600">
			{message}
		</p>
	);
}
